// verseLabelArrows4ResultReducer.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  showLeftArrowVerseSearch: false,
  showRightArrowVerseSearch: false,
  showfabContentVerseSearch: false,
  showLeftArrowNote: false,
  showRightArrowNote: false,
  showfabContentNote: false,  
  showLeftArrowNoteSearch: false,
  showRightArrowNoteSearch: false,
  showfabContentNoteSearch: false,  
};

const verseLabelArrows4ResultSlice = createSlice({
  name: 'verseLabelArrows4Result',
  initialState,
  reducers: {
    setShowLeftArrowVerseSearch(state, action) {
      state.showLeftArrowVerseSearch = action.payload;
    },
    setShowRightArrowVerseSearch(state, action) {
      state.showRightArrowVerseSearch = action.payload;
    },
    setShowfabContentVerseSearch(state, action) {
      state.showfabContentVerseSearch = action.payload;
    },
    setShowLeftArrowNote(state, action) {
      state.showLeftArrowNote = action.payload;
    },
    setShowRightArrowNote(state, action) {
      state.showRightArrowNote = action.payload;
    },
    setShowfabContentNote(state, action) {
      state.showfabContentNote = action.payload;
    },
    setShowLeftArrowNoteSearch(state, action) {
      state.showLeftArrowNoteSearch = action.payload;
    },
    setShowRightArrowNoteSearch(state, action) {
      state.showRightArrowNoteSearch = action.payload;
    },
    setShowfabContentNoteSearch(state, action) {
      state.showfabContentNoteSearch = action.payload;
    },
    reset4verseLabelArrows4Result() {
      return initialState;
    },
  },
});

export const { setShowLeftArrowVerseSearch, setShowRightArrowVerseSearch, setShowfabContentVerseSearch, setShowLeftArrowNote, setShowRightArrowNote, setShowfabContentNote, setShowLeftArrowNoteSearch, setShowRightArrowNoteSearch, setShowfabContentNoteSearch, reset4verseLabelArrows4Result } = verseLabelArrows4ResultSlice.actions;
export default verseLabelArrows4ResultSlice.reducer;
// const initialState = {
//   showLeftArrowVerseSearch: false,
//   showRightArrowVerseSearch: false,
//   showfabContentVerseSearch: false,
//   showLeftArrowNote: false,
//   showRightArrowNote: false,
//   showfabContentNote: false,  
//   showLeftArrowNoteSearch: false,
//   showRightArrowNoteSearch: false,
//   showfabContentNoteSearch: false,  
// };

// export default function verseLabelArrows4ResultReducer(state = initialState, action) {
//   switch (action.type) {
//     case 'setShowLeftArrowVerseSearch':
//       return {
//         ...state,
//         showLeftArrowVerseSearch: action.payload, // Update the selected book
//       };
//     case 'setShowRightArrowVerseSearch':
//       return {
//         ...state,
//         showRightArrowVerseSearch: action.payload, // Update the selected book
//       };  
//     case 'setShowfabContentVerseSearch':
//       return {
//         ...state,
//         showfabContentVerseSearch: action.payload, // Update the selected book
//       };           
//     case 'setShowLeftArrowNote':
//       return {
//         ...state,
//         showLeftArrowNote: action.payload, // Update the selected book
//       };
//     case 'setShowRightArrowNote':
//       return {
//         ...state,
//         showRightArrowNote: action.payload, // Update the selected book
//       };  
//     case 'setShowfabContentNote':
//       return {
//         ...state,
//         showfabContentNote: action.payload, // Update the selected book
//       };   
//     case 'setShowLeftArrowNoteSearch':
//       return {
//         ...state,
//         showLeftArrowNoteSearch: action.payload, // Update the selected book
//       };
//     case 'setShowRightArrowNoteSearch':
//       return {
//         ...state,
//         showRightArrowNoteSearch: action.payload, // Update the selected book
//       };  
//     case 'setShowfabContentNoteSearch':
//       return {
//         ...state,
//         showfabContentNoteSearch: action.payload, // Update the selected book
//       };           
//     case 'reset4verseLabelArrows4Result':
//       return initialState;     
//     default:
//       return state;
//   }
// }

// export const setShowLeftArrowVerseSearch = (e) => ({
//   type: 'setShowLeftArrowVerseSearch',
//   payload: e,
// });

// export const setShowRightArrowVerseSearch = (e) => ({
//   type: 'setShowRightArrowVerseSearch',
//   payload: e,
// });

// export const setShowfabContentVerseSearch = (e) => ({
//   type: 'setShowfabContentVerseSearch',
//   payload: e,
// });

// export const setShowLeftArrowNote = (e) => ({
//   type: 'setShowLeftArrowNote',
//   payload: e,
// });

// export const setShowRightArrowNote = (e) => ({
//   type: 'setShowRightArrowNote',
//   payload: e,
// });

// export const setShowfabContentNote = (e) => ({
//   type: 'setShowfabContentNote',
//   payload: e,
// });

// export const setShowLeftArrowNoteSearch = (e) => ({
//   type: 'setShowLeftArrowNoteSearch',
//   payload: e,
// });

// export const setShowRightArrowNoteSearch = (e) => ({
//   type: 'setShowRightArrowNoteSearch',
//   payload: e,
// });

// export const setShowfabContentNoteSearch = (e) => ({
//   type: 'setShowfabContentNoteSearch',
//   payload: e,
// });

// export const reset4verseLabelArrows4Result  = (e) => ({
//   type: 'reset4verseLabelArrows4Result',
//   payload: e,
// });